import { Box, Grid, ListItemButton, ListItemIcon, ListItemText, Paper, Typography, useMediaQuery, Button, Menu, MenuItem } from '@mui/material';
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import { ReactChildren } from '../../interfaces/Common';
import KenLoader from '../../GlobalComponents/KenLoader';
import { getUserDetails } from '../../storageService';
import { getStudentInfo } from '../../Utils/apiService';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import DefaultProfileImage from '../../Assets/image1.png'
import Image from '../../Assets/assetHelper';
// import { getBasicProfileSetting } from '../../Utils/apiService';
// import mixpanel from 'mixpanel-browser';
import KenDialog from '../../GlobalComponents/KenDialog';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const {
    state: { user, studentInfo: cachedStudentInfo },
    dispatch,
  } = useContext(AuthContext);
  const { state: appState } = useAppContext();
  const isFullscreen = !!appState.isFullscreen;
  console.log("User from AuthContext:", user);
  const userData = user as AuthUser;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [profileUrl, setProfileUrl] = useState('');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');

  const [studentInfo, setStudentInfo] = useState({
    fullName: cachedStudentInfo?.fullName ?? "",
    Profile: cachedStudentInfo?.Profile ?? ""
  });

  const [loading, setLoading] = useState<boolean>(!cachedStudentInfo);
  const [error, setError] = useState<string | null>(null);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  useEffect(() => {
    // Already cached in AuthContext (survives navigation) — avoid refetching
    // getStudentInfo on every page mount just for the header name/photo.
    if (cachedStudentInfo) {
      setStudentInfo(cachedStudentInfo);
      setLoading(false);
      return;
    }
    let isMounted = true;
    const userDetails = getUserDetails();
    if (userDetails?.ContactId) {
      getStudentInfo(userDetails.ContactId)
        .then((data) => {
          if (!isMounted) return;
          const info = {
            fullName: `${data?.firstName} ${data?.lastName}`,
            Profile: data?.profile
          };
          setStudentInfo(info);
          dispatch({ type: 'SET_STUDENT_INFO', payload: { studentInfo: info } });
        })
        .catch(() => {
          if (isMounted) setError("Failed to load student details.");
        })
        .finally(() => {
          if (isMounted) setLoading(false);
        });
    } else {
      setLoading(false);
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cachedStudentInfo]);
  if (loading) return <KenLoader />;
  if (error) return <Typography color="error">{error}</Typography>;
  const performLogout = () => {
    // Calculate session duration
    const sessionEndTime = new Date().getTime();
    const sessionStartTime = localStorage.getItem("sessionStartTime");

    let timeSpent = "0 min 0 sec";

    if (sessionStartTime) {
      let durationMs = sessionEndTime - parseInt(sessionStartTime);

      let hours = Math.floor(durationMs / (1000 * 60 * 60));
      let minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((durationMs % (1000 * 60)) / 1000);


      if (hours > 0) {
        timeSpent = `${hours} hr ${minutes} min ${seconds} sec`;
      } else {
        timeSpent = `${minutes} min ${seconds} sec`;
      }

      console.log(`Duration: ${timeSpent}`);
    }

    // mixpanel.track("User Logged Out", {
    //   time: new Date().toISOString(),
    //   timeSpent: timeSpent,
    // });

    // mixpanel.reset();
    dispatch({ type: "LOGOUT" });
    navigate(routes.login);
  };

  const handleListClick = (path: string, index: number) => {
    console.log("path", path);
    if (path === "/login") {
      setLogoutConfirmOpen(true);
      return;
    }
    navigate(path);
  };

  const handleLogoutConfirm = () => {
    setLogoutConfirmOpen(false);
    performLogout();
  };

  const handleLogoutCancel = () => {
    setLogoutConfirmOpen(false);
  };
  
  


  // useEffect(() => {
  //   getBasicProfileSetting(userData?.applicantId)
  //     .then((res) => {
  //       console.log('353454353', res);
  //       setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }, []);
  console.log('innerwidth12', window.innerWidth);

  // isFullscreen (set while a student is taking a quiz attempt) hides the
  // sidebar/top bar via CSS rather than branching the returned JSX tree —
  // switching between structurally different trees would unmount `children`
  // (and everything's state, e.g. the quiz attempt in progress) since React
  // can't reconcile two unrelated element trees as the same subtree.
  return (
    <>
      {isMobile ? (
        <Grid container spacing={2} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={12} sm={12} sx={{ display: isFullscreen ? 'none' : undefined }}>
            <Paper sx={{ mt: 2, ml: 2, mb: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={2} alignItems="center" xs={12} lg={12}>
                <Grid item xs={2}>
                  <div>
                    <Button id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
                      <img
                        className={classes.profilImageMobileView}
                        src={userData?.applicationProfile ? userData.applicationProfile : (studentInfo.Profile || DefaultProfileImage)}
                        alt="profile"
                        style={{ width: '40px', height: '40px', cursor: 'pointer', borderRadius: '50%', objectFit: 'cover' }}
                        // onClick={() => navigate(routes.settings)}
                      />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      sx={{ '& .MuiPaper-root': { minWidth: 220 } }}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <SideNavTabs
                        showLabelsOnSmallScreens
                        handleListClick={(path, index) => {
                          handleListClick(path, index);
                          handleClose();
                        }}
                      />
                    </Menu>
                  </div>
                </Grid>
                <Grid item xs={5.5}>
                  <AppBreadCrumbs />
                </Grid>
                <Grid item xs={4.5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      background: '#fff',
                      borderRadius: '10px',
                      padding: '4px 10px',
                    }}
                  >
                    <Box
                      component="img"
                      src={Image.Images.headerLogo}
                      alt="L&T CTT"
                      sx={{ width: 28, height: 28, objectFit: 'contain', borderRadius: '6px', flexShrink: 0 }}
                    />
                    <Box sx={{ textAlign: 'right', lineHeight: 1.2 }}>
                      <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#212B38' }}>L&amp;T CTT</Typography>
                      <Typography sx={{ fontSize: '8.5px', fontWeight: 700, letterSpacing: '0.04em', color: '#1B7EC2' }}>
                        SKILLING LMS
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={isFullscreen ? 12 : undefined} sm={isFullscreen ? 12 : undefined}>
            <Box
              sx={{
                overflow: 'auto',
                // overflow: isMobile ? 'auto' : 'hidden',
                // height: '100vh',
                // width: '100vw',
                height: '100vh',
                width: '100vw',
                scrollbarColor: 'white',
                p: 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container sx={{ width: '100vw', height: '100vh', margin: 0 }}>
          <Grid
            item
            sx={{
              padding: '0 !important',
              display: isFullscreen ? 'none' : undefined,
              flex: '0 0 264px',
              width: '264px',
              maxWidth: '264px',
            }}
          >
            <Paper className={classes.nav}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px',marginTop: '24px' }}>
                  <img
                    className={classes.profilImage}
                    // src={profileUrl ? profileUrl : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU"}
                    src={studentInfo.Profile ? studentInfo.Profile : DefaultProfileImage}
                    alt="profile"
                    style={{
                      width: isMobile ? '40px' : '84px',
                      height: isMobile ? '40px' : '84px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      border: "2px solid #1B7EC2"
                    }}
                    onClick={() => navigate(routes.myProfile)}
                  />
                  <Typography className={classes.profileName}>
                    {studentInfo.fullName || ''}
                  </Typography>
                </div>
                <div>
                <SideNavTabs handleListClick={handleListClick}  />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid
            item
            sx={{
              padding: '0 !important',
              flex: '1 1 0',
              width: isFullscreen ? '100%' : 'calc(100% - 264px)',
              minWidth: 0,
            }}
          >
            <Grid container direction="column" sx={{ height: '100%', flexWrap: 'nowrap' }}>
              <Grid item sx={{ display: isFullscreen ? 'none' : 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '24px 32px 16px' }}>
                <Box>
                  <AppBreadCrumbs />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      background: '#fff',
                      borderRadius: '12px',
                      padding: '6px 12px',
                    }}
                  >
                    <Box
                      component="img"
                      src={Image.Images.headerLogo}
                      alt="L&T CTT"
                      sx={{ width: 32, height: 32, objectFit: 'contain', borderRadius: '8px', flexShrink: 0 }}
                    />
                    <Box sx={{ textAlign: 'right', lineHeight: 1.2 }}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#212B38' }}>L&amp;T CTT</Typography>
                      <Typography sx={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.04em', color: '#1B7EC2' }}>
                        SKILLING LMS
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Box
                sx={{
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  flexGrow: 1,
                  height: isFullscreen ? '100vh' : 'calc(100vh - 90px)',
                  maxHeight: isFullscreen ? '100vh' : 'calc(100vh - 90px)',
                  width: '100%',
                  scrollbarColor: 'white',
                  paddingTop: isFullscreen ? '32px' : '3px',
                  paddingLeft: '32px',
                  paddingRight: '32px',
                  paddingBottom: '48px',
                  scrollbarWidth: 'none',
                  position: 'relative',
                  zIndex: 1,
                  textAlign: 'left',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}
      <KenDialog
        open={logoutConfirmOpen}
        handleClose={handleLogoutCancel}
        title="Log out?"
        titleContainerStyles={{ fontSize: '20px', fontWeight: 700 }}
        dialogText={<span style={{ fontSize: '15px' }}>Are you sure you want to log out of your account?</span>}
        maxWidth="xs"
        dialogActions
        dialogActionProps={{ sx: { justifyContent: 'flex-end', padding: '16px', gap: '12px' } }}
        negativeButtonText="Cancel"
        positiveButtonText="Logout"
        negativeButtonClick={handleLogoutCancel}
        positiveButtonClick={handleLogoutConfirm}
      />
    </>
  );
};

export default AppLayout;
